/** One short rule shared by the description and pricing prompts. */
export const CONSTRUCTION_GEOMETRY_PROMPT = `
EXTENSION WALLS: count only the new wall/foundation runs actually built (e.g. an attached rear extension usually has a rear wall plus its returns; the house wall is retained), never the full 2×(length+width) rectangle unless all four sides are new. List each run separately (e.g. rear 10m + left return 4m + right return 4m = 18m).
`;

export const isConstructionRun = (label: string) =>
  /\b(?:run|return)\b/i.test(label) && /\b(?:wall|foundation|trench|roof|parapet|edge|gutter|flashing)\b/i.test(label);
